import { Box, Fab, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Fibonacci, FiboType, Finish } from "../types";
import FiboDetails from "./FiboDetails";
import fibo, { defaultLabel, fiboSelectors } from "./store/fibo";
import { v4 as generateUuid } from "uuid";
import ui from "./store/ui";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  fab: {
    position: "absolute",
    right: 0,
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  fabIcon: {
    marginRight: theme.spacing(),
  },
}));

const defaultFibo = (currentAmount: number): Fibonacci => ({
  id: generateUuid(),
  amount: 1,
  label: [defaultLabel(), defaultLabel()],
  description: `New Fibonacci (${currentAmount + 1})`,
  type: FiboType.Quad,
  finish: Finish.BrushedAluminium,
});

function FiboList() {
  const classes = useStyles();

  const dispatch = useDispatch();
  const allFibos = useSelector(fiboSelectors.selectAll);

  const addFibo = useCallback(() => {
    const newFibo = defaultFibo(allFibos.length);
    dispatch(fibo.actions.fiboAdded(newFibo));
    dispatch(ui.actions.setActiveId(newFibo.id));
  }, [allFibos, dispatch]);

  useEffect(() => {
    if (!allFibos.length) addFibo();
  }, [addFibo, allFibos]);

  return (
    <Box className={classes.root}>
      <Box mt={4}>
        {allFibos.map((fibo) => (
          <FiboDetails key={fibo.id} id={fibo.id} />
        ))}
      </Box>
      <Box className={classes.fab}>
        <Fab variant="extended" color="primary" onClick={addFibo}>
          <AddIcon className={classes.fabIcon} />
          Add Fibonacci
        </Fab>
      </Box>
    </Box>
  );
}

export default FiboList;
